import React from 'react';

import { OpenBanking as OpenBankingScreen } from '@devsbb/auth-ui';

const OpenBanking = () => <OpenBankingScreen />;

export default OpenBanking;
